import serverVars from 'server-vars';
import { localStorage, sessionStorage } from 'dibs-browser-storage';
import { isMasquerading } from 'dibs-cookie-jar';
import { getMeasurementUnit } from 'dibs-intl/exports/intlSupport';
import {
    getSourceAttribution,
    clearSourceAttribution,
} from 'dibs-visit-tracking/exports/sourceAttribution';

import { getCurrencyPreference } from '../../utils/preferredCurrency';
import { getGuestId, deleteGuestId } from '../../utils/guestIdStorage';
import { GUEST_CHECKOUT } from '../../utils/userTracking';
import { userProfileMutation } from '../mutations/userProfileMutation';
import { sourceAttributionMutation } from './sourceAttributionMutation';
import * as constants from './userStorageConstants';

import { AuthResponseType } from './authTypes';

const clearGuestCheckoutEntry = (): void => {
    sessionStorage.deleteItem(GUEST_CHECKOUT);
};

// Do not write client-side cookies for long-term storage!! see https://1stdibs.atlassian.net/browse/ENGAGE-979
// submits guestId to sourceAttribution call and adds user data to localStorage
export const setTokens = (payload: AuthResponseType): void => {
    const { environment, user, emailToken, userId, userToken } = payload || {};

    const { profile = {} } = user || {};
    const guestUserId = getGuestId();

    if (guestUserId && !isMasquerading(document.cookie)) {
        sourceAttributionMutation(environment, {
            guestUserId,
            type: constants.GUEST_USER,
            userId,
            userToken,
            emailToken,
            pageVisits: getSourceAttribution(),
        });
        deleteGuestId();
    }
    clearSourceAttribution();
    clearGuestCheckoutEntry();

    if (profile.email) {
        localStorage.setItem(constants.USER_EMAIL, profile.email);
    }
    if (emailToken) {
        localStorage.setItem(constants.USER_EMAIL_TOKEN, emailToken);
    }
};

export const resetVisitCount = (): void => {
    const visitCount =
        (localStorage.getItem(constants.VISIT_COUNT) as {
            regPromptLimit: number;
            totalVisitCount: number;
        }) || {};
    const { regPromptLimit = constants.REG_PROMPT_LIMIT, totalVisitCount = 0 } = visitCount;
    localStorage.setItem(constants.VISIT_COUNT, {
        totalVisitCount,
        sinceRegPrompt: 0,
        regPromptLimit,
    });
};

export const updateProfile = (payload: AuthResponseType): Promise<AuthResponseType> => {
    const { environment, userId } = payload;
    const locale = serverVars.get('locale');
    const currency = getCurrencyPreference();
    const measurementUnit = getMeasurementUnit(locale);
    return new Promise(resolve => {
        userProfileMutation(environment, {
            currency,
            measurementUnit,
            preferredLocale: locale,
            userServiceId: userId,
            onCompleted: () => {
                resolve(payload);
            },
            // don't reject - if this mutation fails do not show the user an error
            onError: () => resolve(payload),
        });
    });
};
